<template>
  <q-inner-loading v-if="loading" showing color="secondary" />
  <market-report v-else :report="report" />
</template>

<script lang="ts">
import { useMarketReportStore } from '@/stores/marketreport'
import type { MarketReportSubscriptionAttributes } from 'common'
import MarketReport from '@/components/MarketReports/MarketReport.vue'

export default {
  name: 'MarketReportView',
  components: {
    MarketReport
  },
  props: {
    reportId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      report: null as MarketReportSubscriptionAttributes | null
    }
  },
  watch: {
    reportId() {
      this.loadReport()
    }
  },
  created() {
    this.loadReport()
  },
  methods: {
    loadReport() {
      this.loading = true
      useMarketReportStore()
        .get(parseInt(this.reportId))
        .then((response) => {
          if (!response) {
            this.$router.push({ name: 'Regional Reports' })
          } else {
            this.report = response
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
